import React, { useState } from "react";

import { Button, ButtonVariant } from "@cofano/cck";

import {
	Button as MuiButton,
	ButtonGroup,
	useMediaQuery,
	useTheme,
	Menu,
	MenuItem,
} from "@mui/material";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const PageHeaderButtons = ({
	items,
}: {
	items: { label: string; onClick: () => void; visible: boolean; variant: ButtonVariant, loading?: boolean }[];

}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("md"));

	const [ anchorEl, setAnchorEl ] = useState<HTMLButtonElement | null>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const filteredItems = items.filter((it) => it.visible);
	if (filteredItems.length === 0) {
		return null;
	}

	if (isMobile && filteredItems.length > 1) {
		const [ primaryItem, ...restItems ] = filteredItems;

		return (
			<React.Fragment>
				<ButtonGroup variant='contained'>
					<MuiButton onClick={primaryItem.onClick}>{primaryItem.label}</MuiButton>

					<MuiButton onClick={handleClick}>
						<ArrowDropDownIcon />
					</MuiButton>
				</ButtonGroup>

				<Menu
					anchorEl={anchorEl}
					open={open}
					onClose={handleClose}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "right",
					}}
					transformOrigin={{
						vertical: "top",
						horizontal: "right",
					}}
				>
					{restItems.map((it) => (
						<MenuItem
							key={it.label}
							onClick={() => {
								handleClose();
								it.onClick();
							}}
							sx={{ minHeight: 36 }}>
							{it.label}
						</MenuItem>
					))}
				</Menu>
			</React.Fragment>
		);
	} else {
		return filteredItems.map((it) => (
			<Button
				key={it.label}
				onClick={it.onClick}
				variant={it.variant}
				loading={it.loading}>
				{it.label}
			</Button>
		));
	}
};

export default PageHeaderButtons;
